import { formatPhoneDigits } from '@domain/value-objects/PhoneNumber';

/**
 * La máscara del teléfono mientras se escribe.
 *
 * Agrupa lo que es teléfono y devuelve el resto intacto, por el mismo motivo que
 * `formatStoredPhone`: reescribir por posiciones algo que no son diez dígitos
 * sale ilegible y, peor, esconde que el dato está mal.
 *
 * Que exista lo segundo no es hipotético. En producción hay catorce expedientes
 * con teléfonos de once y doce cifras —«554435074820», «44433930445»—, herencia
 * del Excel. Pasados por `formatPhoneDigits` a secas salen como «55 4435 0748 20»,
 * que parece un teléfono y no lo es.
 *
 * Acepta valores a medias porque es exactamente lo que hay en el campo entre la
 * primera tecla y la décima.
 */
export const maskDraftPhone = (draft: string): string =>
  /^[0-9]{0,10}$/.test(draft) ? formatPhoneDigits(draft) : draft;
